import { Card, CardContent } from "@/components/ui/card";
import { MapPin, Calendar, Landmark } from "lucide-react";
import invitationImg from "@/assets/invitation-diner-senat.png";

export default function SenatDinnerInscription() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#E8F0F8] via-[#F5F8FC] to-[#E8F0F8]">
      <div className="bg-[#001233] py-4 px-6">
        <div className="container mx-auto flex items-center gap-3">
          <Landmark className="h-8 w-8 text-[#FFFD4C]" />
          <h1 className="text-xl md:text-2xl font-bold text-white font-acumin">
            Enfants de la République
          </h1>
        </div>
      </div>

      <main className="container mx-auto px-4 py-8 md:py-12">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-5xl font-bold text-[#001233] mb-4">
            Dîner au Sénat
          </h2>
          <p className="text-lg md:text-xl text-[#001233]/80 mb-2">
            Présentation de l'Indice de la Citoyenneté Française (ICF 2025)
          </p>
          <p className="text-sm md:text-base text-[#001233]/70 italic mb-6">
            Sous le parrainage de Monsieur Bernard Fialaire, Sénateur du Rhône
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8 text-[#001233]/90">
            <div className="flex items-center gap-2">
              <Calendar className="h-5 w-5 text-[#00509E]" />
              <span className="text-lg font-medium">Mardi 16 juin 2026 — 19h15</span>
            </div>
            <div className="flex items-center gap-2">
              <MapPin className="h-5 w-5 text-[#00509E]" />
              <span className="text-lg font-medium">Palais du Luxembourg, Paris</span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto items-start">
          <div className="order-2 md:order-1">
            <img
              src={invitationImg}
              alt="Invitation au dîner au Sénat du 16 juin 2026"
              className="w-full rounded-lg shadow-xl border border-black/10"
            />
          </div>

          <div className="order-1 md:order-2">
            <Card className="border-0 shadow-2xl">
              <CardContent className="pt-8 pb-8 text-center">
                <h3 className="text-2xl font-bold text-[#001233] mb-4">
                  Inscriptions closes
                </h3>
                <p className="text-base text-[#001233]/80 mb-4">
                  Les inscriptions au dîner au Sénat du 16 juin 2026 sont désormais closes.
                </p>
                <p className="text-sm text-[#001233]/70">
                  Nous vous remercions de l'intérêt porté à cet événement. Pour toute question,
                  vous pouvez nous contacter à{" "}
                  <a href="mailto:contact@edlr.fr" className="text-[#00509E] font-medium underline">
                    contact@edlr.fr
                  </a>.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>

      <footer className="py-6 text-center text-[#001233]/50 text-sm">
        <p>© 2026 Enfants de la République — Dîner au Sénat</p>
        <p className="mt-1">Contact : contact@edlr.fr | www.edlr.org</p>
      </footer>
    </div>
  );
}
